export enum FilterValueType {
    status = 'status',
    entryDate = 'entryDate',
    burialDate = 'burialDate',
    startDate = 'startDate',
    endDate = 'endDate',
    invoiceNumber = 'invoiceNumber'
}
